import React from "react"

import Default from "../../Default"

const ServiceProviders = () => {
  const title = "Service Providers"
  const description = (
    <>
      <p>
        An exciting new service is currently being developed that will allow
        participants to view and interact with nearby service providers using
        intelligent prediction and automated features.
      </p>
    </>
  )

  return <Default title={title} description={description} />
}

export default ServiceProviders
